export const aboutData = {
    title: "About me",
    description1: "Hello, My name is William McCoy. I am an NJIT alumni with a Bachelors degree in Information Technology with a specialization in Cybersecurity. ",
    description2: "As a child, I have always had an interest in all things computers, from games to coding to just generally how they all work. My main objective for the future is to take my love of computers and security and make a meaningful contribution to society. ",
    image: 0
}